import api from "./axios";

export const loginApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/auth/login", payload);

	return response.data;
};

export const verify2faLoginApi = async ({ tempToken, ...payload }: { tempToken?: string | null; [key: string]: unknown }) => {
	const response = await api.post("/api/auth/verify-2fa", payload, {
		headers: tempToken
			? {
					Authorization: `Bearer ${tempToken}`,
				}
			: undefined,
	});

	return response.data;
};

export const registerApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/auth/create-user", payload, {
		withCredentials: true,
	});

	return response.data;
};

export const verifyEmailApi = async ({ email, token }: { email: string; token: string }) => {
	const response = await api.get("/api/auth/verify-email", {
		params: { email, token },
	});

	return response.data;
};

export const resendVerificationEmailApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/auth/resend-link", payload);

	return response.data;
};

export const forgotPasswordApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/auth/password/request-reset", payload);

	return response.data;
};

export const resetPasswordApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/auth/password/reset", payload);

	return response.data;
};

export const enable2faApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/user/2fa/enable", payload);

	return response.data;
};

export const confirm2faApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/user/2fa/confirm", payload);

	return response.data;
};

export const update2faMethodApi = async (payload: Record<string, unknown>) => {
	const response = await api.patch("/api/user/2fa/method", payload);

	return response.data;
};

export const disable2faApi = async () => {
	const response = await api.post("/api/user/2fa/disable");

	return response.data;
};

export const regenerateBackupCodesApi = async () => {
	const response = await api.post("/api/user/2fa/backup-codes/regenerate");

	return response.data;
};

export const getGoogleOAuthUrlApi = async () => {
	const response = await api.get("/api/auth/google");

	return response.data;
};

export const handleGoogleLoginCallbackApi = async ({ code, state }: { code: string; state?: string | null }) => {
	const response = await api.get("/api/auth/google-callback", {
		params: { code, state },
	});

	return response.data;
};

export const searchBusinessesApi = async (query: string) => {
	const response = await api.get("/api/businesses/search", {
		params: {
			q: query,
		},
	});

	return response.data;
};

export const connectBusinessApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/businesses/connect", payload);

	return response.data;
};

export const getConnectedBusinessesApi = async () => {
	const response = await api.get("/api/businesses");

	return response.data;
};
